import { TimelineLayerId } from 'features/mapping/mapping.constants';
import { useMapContext } from 'features/mapping/components/Map/MapContext';
import { TimelinePlayButton } from 'features/mapping/components/timeline/TimelinePlayButton';
import { useTimelineLayerList } from 'features/mapping/hooks/useTimelineLayerList';
import { useTimelineLayerToggle } from 'features/mapping/hooks/useTimelineLayerToggle';
import { LAYERS_DRAWER_PARAM_KEYS } from 'features/mapping/hooks/useLayersDrawerState';

type LayerTimelinePlayActionProps = {
  layerId: TimelineLayerId;
};

// Hidden unless the layer is in the timeline list (lightning needs
// `show_timeline_layers_in_frontend`) and the policy allows timeline mode
// (it doesn't in timeline mode itself).
export const LayerTimelinePlayAction = ({
  layerId,
}: LayerTimelinePlayActionProps): JSX.Element | null => {
  const {
    policy: { allowTimelineControl },
  } = useMapContext();
  const timelineLayers = useTimelineLayerList();
  const toggleTimelineLayer = useTimelineLayerToggle();

  const isInTimelineList = timelineLayers.some(({ id }) => id === layerId);
  if (!allowTimelineControl || !isInTimelineList) return null;

  return (
    <TimelinePlayButton
      layerId={layerId}
      onClick={(): void =>
        toggleTimelineLayer(layerId, {
          removeParams: LAYERS_DRAWER_PARAM_KEYS,
        })
      }
    />
  );
};
